import { Switch, Route } from "react-router-dom";
import StatisticsAndReports from "../../pages/statistics-reports";

import "./internal-screens.scss";
import PagesLayout from "../../components/layout";
import Profile from "../../pages/profile";
import { useState } from "react";
import AssignedRequests from "../../pages/assigned-requests";
import Chatting from "../../pages/chatting";
import RequestsHistory from "../../pages/requests-history";
import RequestDetails from "../../pages/request-details";
import AssignedDetails from "../../pages/assigned-details";
import ApplyRequest from "../../pages/apply-request";


const InternalScreens = ({ match }) => {
  const [defaultKey, setDefaultKey] = useState(1);

  const handleChangeKey = (value) => {
    console.log(value, defaultKey);
    if (defaultKey !== value) setDefaultKey(value);
  };
  return (
    <div className="internal-screens-container">
      <PagesLayout defaultKey={defaultKey}>
        <Switch>
          <Route
            exact
            path={`${match.path}/statistics-reports`}
            render={(props) => (
              <StatisticsAndReports
                handleChangeKey={handleChangeKey}
                {...props}
                title="احصائيات وتقارير"
              />
            )}
          />
          <Route
            exact
            path={`${match.path}/profile`}
            render={(props) => (
              <Profile
                handleChangeKey={handleChangeKey}
                {...props}
                title="الملف الشخصي"
              />
            )}
          />
          <Route
            exact
            path={`${match.path}/assigned-requests`}
            render={(props) => (
              <AssignedRequests
                handleChangeKey={handleChangeKey}
                {...props}
                title="الطلبات المسندة إليه"
              />
            )}
          />
          <Route
            exact
            path={`${match.path}/assigned-requests/:id`}
            render={(props) => (
              <AssignedDetails
                handleChangeKey={handleChangeKey}
                {...props}
                title="تفاصيل الطلب"
              />
            )}
          />
          <Route
            exact
            path={`${match.path}/chatting-page`}
            render={(props) => (
              <Chatting
                handleChangeKey={handleChangeKey}
                {...props}
                title="صفحة النقاش"
              />
            )}
          />
          <Route
            exact
            path={`${match.path}/requests-history`}
            render={(props) => (
              <RequestsHistory
                handleChangeKey={handleChangeKey}
                {...props}
                title="سجل الطلبات"
              />
            )}
          />
          <Route
            exact
            path={`${match.path}/requests-history/:id`}
            render={(props) => (
              <RequestDetails
                handleChangeKey={handleChangeKey}
                {...props}
                title="تفاصيل الطلب"
              />
            )}
          />
          

          <Route
          exact
          path={`${match.path}/apply-request`}
          render={(props) => (
            <ApplyRequest
              handleChangeKey={handleChangeKey}
              {...props}
              title="تقديم الطلبات"
            />
          )}
        />
          

          {/* default router */}
          <Route
            exact
            path={`${match.path}`}
            render={(props) => (
            <AssignedRequests
                handleChangeKey={handleChangeKey}
                {...props}
                title="الطلبات المسندة إليه"
              />
            )}
          />
        </Switch>
      </PagesLayout>
    </div>
  );
};

export default InternalScreens;
